import { LoadingSkeleton } from "@faire/web/slate-deprecated/LoadingSkeleton";
import { Column } from "@faire/web/slate/Layout";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import React from "react";

export const LoadingProductTileSkeleton: React.FC = () => {
  return (
    <Column data-test-id="product-tile-placeholder">
      <LoadingSkeleton width="100%" height="" aspectRatio="1" />
      <Column
        style={{
          padding: getSpacing("2x", 0),
          flex: "1",
          height: getSpacing(112),
        }}
      >
        <Spacer height={4} />
        <LoadingSkeleton width="100%" height="16px" />
        <Spacer height={4} />
        <LoadingSkeleton width="75%" height="16px" />
        <Spacer height={12} />
        <Spacer height={{ mobileAndAbove: 64, tabletAndAbove: 40 }} />
      </Column>
    </Column>
  );
};
